import { REPORT_DASHBOARD } from 'constants/routePaths';

import * as React from 'react';

import { WebAsset } from '@mui/icons-material';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import formatPath from 'utils/formatPath';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
}

const CloneReportMenuItem: React.FC<Props> = ({ handleClose, report }) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      onClick={handleClose}
      component={Link}
      to={formatPath(REPORT_DASHBOARD, {
        reportId: report.reportId,
      })}
    >
      <ListItemButton>
        <ListItemIcon>
          <WebAsset fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('reportsQa.menu.viewReport')} />
      </ListItemButton>
    </MenuItem>
  );
};

export default CloneReportMenuItem;
